import {withRouter} from 'react-router';
import moment from 'moment';

import {withApollo} from 'react-apollo';
import {GetThirdPartyClientTunnelsForClient} from '@graphql/argosJob/query';
import DefaultForm from '@appComponents/DefaultForm';
import {convertToInt} from '@utils/helpers';
import {TIME_TYPE_FIXED, TIME_TYPE_MANUAL, TIME_TYPE_MARGIN} from '@modules/events/forms/ArgosJob/ArgosJobModel';

import {buildSelectOptions, buildTunnelSelectOptions} from '../helpers/argosJob';

export class ArgosJobForm extends DefaultForm {
    constructor(props) {
        super(props);

        if ((this.props.formParams?.eventEndDatetime || this.props.formParams?.isSportradarType)
            && this.props.Model?.fields?.end_time) {
            const endTimeField = this.props.Model.fields.end_time;

            if (endTimeField?.props?.radioOptions) {
                endTimeField.props.radioOptions = endTimeField.props.radioOptions.map(opt => {
                    if ('end_margin' === opt.id) {
                        const inputLabel = this.props.formParams?.eventEndDatetime
                            ? 'minutes after the event end time'
                            : 'minutes after the end of the match';

                        return { ...opt, hidden: false, inputLabel };
                    }

                    return opt;
                });
            }
        }
    }

    async fetchTunnelsForClient(clientId) {
        this.setField('third_party_client_tunnel', {loading: true, options:[]});

        try {
            const result = await this.props.client.query({
                query: GetThirdPartyClientTunnelsForClient,
                variables: {clientId: convertToInt(clientId)},
            });
            const options = buildTunnelSelectOptions(result.data?.thirdPartyClientTunnelsForClient);
            this.setField('third_party_client_tunnel', {options, loading: false});
        } catch {
            this.setField('third_party_client_tunnel', {options: []});
        }
    }

    componentDidMount() {
        super.componentDidMount();

        setupArgosJobFormParsersAndCallbacks(this);

        if (this.props.change) {
            this.props.change('start_time_type', TIME_TYPE_MARGIN);
            this.props.change('start_time_margin', '60');
        }

        if (this.props.change && this.props.Model?.fields?.end_time?.props?.radioOptions) {
            const radioOptions = this.props.Model.fields.end_time.props.radioOptions;
            const availableOptions = radioOptions.filter(opt => !opt.hidden);
            const marginIdx = availableOptions.findIndex(opt => opt.value === TIME_TYPE_MARGIN);

            if (-1 !== marginIdx) {
                this.props.change('end_time_type', TIME_TYPE_MARGIN);
                this.props.change('end_time_margin', '15');
            } else {
                this.props.change('end_time_type', TIME_TYPE_MANUAL);
            }
        }
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
    }

    prepareDataForSubmit(data) {
        let dataToSave = {
            event: this.props.formParams?.optionsVariables?.eventId,
            argos_job_definition: data.job_definition,
            argos_job_region: data.region,
            srt_origin_entry_point: data.entry_point,
            third_party_client_tunnel: data.third_party_client_tunnel,
            description: data.argos_description || null,
            end_datetime: null,
            end_margin: null,
        };

        if (data.start_time_type === TIME_TYPE_MANUAL) {
            dataToSave.start_datetime = null;
            dataToSave.start_margin = null;
        } else if (data.start_time_type === TIME_TYPE_FIXED) {
            dataToSave.start_datetime = moment(data.start_time_fixed).format('YYYY-MM-DD HH:mm:ss');
            dataToSave.start_margin = null;

            if (data.start_time_is_past && data.start_time_margin) {
                dataToSave.start_margin = convertToInt(data.start_time_margin);
            }

        } else if (data.start_time_type === TIME_TYPE_MARGIN) {
            dataToSave.start_datetime = null;
            dataToSave.start_margin = convertToInt(data.start_time_margin);
        }

        if (data.end_time_type === TIME_TYPE_MANUAL) {
            dataToSave.end_datetime = null;
            dataToSave.end_margin = null;
        } else if (data.end_time_type === TIME_TYPE_FIXED) {
            dataToSave.end_datetime = moment(data.end_time_fixed).format('YYYY-MM-DD HH:mm:ss');
            dataToSave.end_margin = null;

            if (data.end_time_is_past && data.end_time_margin) {
                dataToSave.end_margin = convertToInt(data.end_time_margin);
            }

        } else if (data.end_time_type === TIME_TYPE_MARGIN) {
            dataToSave.end_datetime = null;
            dataToSave.end_margin = convertToInt(data.end_time_margin);
        }

        return dataToSave;
    }
}

export function setupArgosJobFormParsersAndCallbacks(ctx) {
    ctx.setOptionParsers({
        job_definition: buildSelectOptions,
        region: buildSelectOptions,
        entry_point: buildSelectOptions,
    });

    ctx.setOnChangeCallback({
        tunnel_clients: async (data) => {
            ctx.setField('third_party_client_tunnel', {
                hidden: !data.value,
            });

            if (data.value) {
                await ctx.fetchTunnelsForClient(data.value);
            }
        },
    });
}

export default withRouter(withApollo(ArgosJobForm));
